import xhr from 'xhr';

import configureApp from './configureApp';

export default function(cdn, config) {
  return new Promise((resolve, reject) => {
    xhr.get(`${config.demoUrl}/api/v1/datasets?orgId=${config.demoOrgId}`, { json: true }, (err, request) => {
      if (err) {
        reject({
          message: `unable to fetch the dataset for org: ${config.demoOrgId}`,
          error: err,
        });
        return;
      }

      if (request.statusCode === 200) {
        resolve(request.body);
        return;
      }
      reject({
        message: `unable to fetch the dataset for org: ${config.demoOrgId}`,
        error: new Error(`statusCode: ${request.statusCode}`),
      });
    });
  }).then(dataset => configureApp(cdn, config, dataset));
}
